export {
  default as kitchen,
  ReactComponent as Kitchen,
} from '@assets/icons/features-and-amenities/kitchen.svg'    
